module.exports = __webpack_public_path__ + "static/media/customize-icon.9ecb01b5.svg";